import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Layout route for a single course. The index (`courses.$id.index.tsx`) renders
 * the course detail page; child routes like `courses.$id.topic.$topic.tsx` (the
 * full-page topic view) render through this Outlet. Without this Outlet the
 * topic URL would change but its page would never mount.
 */
export const Route = createFileRoute('/courses/$id')({
  component: () => <Outlet />,
});
